import {
  getAssignedSalesManagers,
  ZohoUserAssignmentPageKey,
} from '@internal/services/TSalesManager'
import { SalesManagerContext } from '@internal/utils/SalesManager/SalesManagerContext'
import { useFeatureFlag } from '@internal/utils/featureFlags/useFeatureFlag'
import { TLocale } from '@internal/utils/machine/i18n/Locale'
import { useMediaQuery } from '@renderer-ui-library/mui/utils/mediaQuery/useMediaQuery'
import React, { useContext, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { MachineDetailsContactButtons } from './MachineDetailsContactButtons'
import { MachineDetailsContactInfo } from './MachineDetailsContactInfo'
import styles from './machineDetailsContact.module.scss'

interface Props {
  machineGroupId: string
  locale: TLocale
}

export const MachineDetailsContact: React.FC<Props> = React.memo(
  ({ machineGroupId, locale }) => {
    const { isMobile } = useMediaQuery()
    const { salesManagers: allSalesManagers } = useContext(SalesManagerContext)
    const { hasFeature } = useFeatureFlag()
    const isZohoUsersFeatureEnabled = hasFeature('zohoUsers')

    const salesManagers = useMemo(() => {
      if (!isZohoUsersFeatureEnabled) {
        return allSalesManagers
      }

      return getAssignedSalesManagers(
        allSalesManagers,
        ZohoUserAssignmentPageKey.ProductDetails
      )
    }, [allSalesManagers, isZohoUsersFeatureEnabled])

    if (salesManagers.length === 0) {
      return null
    }

    return (
      <>
        {!isMobile ? (
          <MachineDetailsContactInfo
            salesManagers={salesManagers}
            machineGroupId={machineGroupId}
            locale={locale}
          />
        ) : (
          <>
            <MachineDetailsContactButtons
              isMobile
              contact={salesManagers[0]}
              machineGroupId={machineGroupId}
              locale={locale}
            />
            {createPortal(
              <div className={styles.mobilButtonsOverlay} />,
              document.body
            )}
          </>
        )}
      </>
    )
  }
)

MachineDetailsContact.displayName = 'MachineDetailsContact'
